'use strict';

import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';


Vue.use(Vuetify, {
	iconfont: 'mdi',
	theme: {
		primary: '3aaa37',
		comment: 'c5e1a5',
		feedback: 'b2dfdb',
	},
});
